import axiosInstance from "../AxiosInstance";
import { GET_COMPANIES, UPDATE_COMPANY_FLAG } from "./CompanyFlagsEndpoints";

export function getCompanies(currentPage, limit, search) {
  return axiosInstance.get(
    GET_COMPANIES +
      `?page=${currentPage}&limit=${limit}&search=${encodeURIComponent(search)}`
  );
}

export function updateCompanyFlag(data) {
  return axiosInstance.put(UPDATE_COMPANY_FLAG, data);
}
